var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCartOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#dfdfdf",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640-452h-35L256-800h529q26 0 38 21.5t-2 46.5L680-476q-6 11-15 17.5t-25 6.5ZM287-81q-29 0-50.5-21T215-153q0-30 21.5-51t50.5-21q29 0 50.5 21t21.5 51q0 30-21.5 51T287-81Zm564 46L595-289H277q-38 0-56-27.5t1-59.5l70-117-86-187L46-840l43-43L894-78l-43 43ZM535-349 434-453h-95l-63 104h259ZM688-81q-29 0-50.5-21T616-153q0-30 21.5-51t50.5-21q29 0 50.5 21t21.5 51q0 30-21.5 51T688-81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartOff);
export default __webpack_public_path__ + "static/media/shopping_cart_off.b315170a3e54221ed91817e30254bae0.svg";
export { ForwardRef as ReactComponent };